const map = {
	"./communication-services.svg": 26471,
	"./consumer-discretionary.svg": 23033,
	"./consumer-staples.svg": 25435,
	"./energy.svg": 97054,
	"./financials.svg": 85430,
	"./government.svg": 6251,
	"./health-care.svg": 91594,
	"./industrials.svg": 90618,
	"./information-technology.svg": 851,
	"./materials.svg": 98788,
	"./real-estate.svg": 71391,
	"./utilities.svg": 23010
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43953;